import React from 'react'

import './styles.scss'

type Props = {
  title: string
  description?: string
  id?: string
}

const PageSectionTitle: React.FC<Props> = ({ title, description, id }) => {
  const headingId = id ?? `${title.toLowerCase().replace(/\s+/g, '-')}-heading`
  return (
    <div className='page-section-title'>
      <h6 id={headingId}>
        {title}
      </h6>
      {description != null && (
        <div className='pt-2 page-section-title__lead d-none d-md-block'>{description}</div>
      )}
    </div>
  )
}

export default PageSectionTitle
